// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as TestUtils$OrcaPaymentPage from "../Utilities/TestUtils.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as PaymentType$OrcaPaymentPage from "../Types/PaymentType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentField$OrcaPaymentPage from "./PaymentField.bs.js";
import * as EmailValidation$OrcaPaymentPage from "../../shared-code/sdk-utils/validation/EmailValidation.bs.js";

function EmailPaymentInput(props) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userEmailAddress);
  var setEmail = match$1[1];
  var email = match$1[0];
  var match$2 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var showDetails = PaymentType$OrcaPaymentPage.getShowDetails(match$2.fields.billingDetails);
  var emailRef = React.useRef(null);
  var changeEmail = function (ev) {
    var val = ev.target.value;
    setEmail(function (prev) {
          return {
                  value: val,
                  isValid: EmailValidation$OrcaPaymentPage.isEmailValid(val),
                  errorString: Core__Option.getOr(EmailValidation$OrcaPaymentPage.isEmailValid(val), false) ? "" : prev.errorString
                };
        });
  };
  var onBlur = function (ev) {
    var val = ev.target.value;
    setEmail(function (prev) {
          var newrecord = Caml_obj.obj_dup(prev);
          newrecord.isValid = EmailValidation$OrcaPaymentPage.isEmailValid(val);
          return newrecord;
        });
  };
  React.useEffect((function () {
          setEmail(function (prev) {
                var newrecord = Caml_obj.obj_dup(prev);
                var val = prev.isValid;
                newrecord.errorString = val !== undefined && !val ? localeString.emailInvalidText : "";
                return newrecord;
              });
        }), [email.isValid]);
  var submitCallback = React.useCallback((function (ev) {
          var json = Utils$OrcaPaymentPage.safeParse(ev.data);
          var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
          if (confirm.doSubmit && email.value === "") {
            return setEmail(function (prev) {
                        var newrecord = Caml_obj.obj_dup(prev);
                        newrecord.errorString = localeString.emailEmptyText;
                        return newrecord;
                      });
          }
          
        }), [email]);
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: showDetails.email === "Auto",
              children: React.createElement(PaymentField$OrcaPaymentPage.make, {
                    setValue: setEmail,
                    value: email,
                    onChange: changeEmail,
                    onBlur: onBlur,
                    fieldName: localeString.emailLabel,
                    name: TestUtils$OrcaPaymentPage.emailInputTestId,
                    type_: "email",
                    placeholder: "Eg: johndoe@gmail.com",
                    inputRef: emailRef
                  })
            });
}

var make = EmailPaymentInput;

export {
  make ,
}
/* react Not a pure module */
